import * as React from "react";
import { DropdownMenu } from "@radix-ui/themes";
import { DotsHorizontalIcon } from "@radix-ui/react-icons";
import { CardIconButton } from "./ItemActions.tsx";

interface Props {
  children?: React.ReactNode;
}

/** Everything else you can do with an item, behind the "…" on its card. */
export const ItemMenu: React.FC<Props> = ({ children }) => {
  return (
    <DropdownMenu.Root modal={false}>
      <DropdownMenu.Trigger>
        <CardIconButton label="More">
          <DotsHorizontalIcon />
        </CardIconButton>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content align="end" style={{ minWidth: "190px" }}>
        {children}
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};
